<template>
  <v-card id="listener_controllo_qualita">
    <v-toolbar color="indigo" dense>
      <v-row align="center">
        <v-col cols="5" align="left">
          <v-toolbar-title class="white--text">
            {{
              tipo_operazione === "CAMPIONATURA"
                ? "Campionatura"
                : tipo_operazione === "CONTROLLOMP"
                ? "Controllo Inizio Lotto"
                : "Controllo Qualità"
            }}
            per {{ work_order_sel.cod_articolo }}
          </v-toolbar-title>
        </v-col>
        <v-col cols="2" align="center">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="clickSetControlli" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Salva</span>
          </v-tooltip>
        </v-col>
        <v-col cols="5" align="right">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="clickChiudi" small v-bind="attrs" v-on="on">
                <v-icon color="error">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-col>
      </v-row>
    </v-toolbar>

    <v-card-text
      class="mt-0"
      style="max-height: 78vh; overflow-y: auto !important"
    >
      <v-container fluid>
        <v-row dense>
          <v-col cols="12" align="left">
            <span class="mr-10" style="font-size: 18px">
              <span style="font-weight: bold">id. testata:</span>
              {{ testata_id }}
            </span>

            <span class="mr-10" style="font-size: 18px">
              <span style="font-weight: bold">revisione:</span>
              {{ testata_revisione }}
            </span>

            <span style="font-size: 18px">
              <span style="font-weight: bold">generato da:</span>
              {{ id_famiglia_articolo == null ? "Articolo" : "Famiglia" }}
            </span>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12">
            <v-data-table
              class="elevation-2"
              :headers="
                this.tipo_operazione === 'CONTROLLO'
                  ? items_controllo.filter((c) => c.genere == 1).length > 0 &&
                    items_controllo.filter((c) => c.genere != 1).length > 0
                    ? headers_controllo_selezionati
                    : items_controllo.filter((c) => c.genere == 0).length > 0 &&
                      items_controllo.filter((c) => c.genere != 0).length == 0
                    ? headers_controllo_selezionati.filter(
                        (h) =>
                          h.value != 'valore' &&
                          h.value != 'valore_min' &&
                          h.value != 'valore_max' &&
                          h.value != 'tolleranza'
                      )
                    : headers_controllo_selezionati
                  : items_controllo.filter((c) => c.genere == 1).length > 0 &&
                    items_controllo.filter((c) => c.genere != 1).length > 0
                  ? headers_controllo_selezionati
                  : items_controllo.filter((c) => c.genere == 0).length > 0 &&
                    items_controllo.filter((c) => c.genere != 0).length == 0
                  ? headers_controllo_selezionati.filter(
                      (h) =>
                        h.value != 'valore' &&
                        h.value != 'valore_min' &&
                        h.value != 'valore_max' &&
                        h.value != 'tolleranza' &&
                        h.value != 'frequenza' &&
                        h.value != 'note'
                    )
                  : headers_controllo_selezionati.filter(
                      (h) => h.value != 'frequenza'
                    )
              "
              height="50vh"
              :items="items_controllo"
            >
              <template v-slot:top>
                <v-toolbar class="mb-2" color="indigo" dense>
                  <!-- Pulsante modifica colonne. -->
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        small
                        class="mr-5"
                        v-bind="attrs"
                        v-on="on"
                        @click="dialog_header_detail = true"
                      >
                        <v-icon color="primary">mdi-cog</v-icon>
                      </v-btn>
                    </template>
                    <span>Modifica colonne</span>
                  </v-tooltip>

                  <v-toolbar-title class="white--text"
                    >Caratteristiche</v-toolbar-title
                  >
                </v-toolbar>
              </template>

              <!-- Colonna della Frequenza -->
              <template v-slot:[`item.num_riga`]="{ index }">
                {{ index + 1 }}
              </template>

              <!-- Colonna della Frequenza -->
              <template v-slot:[`item.frequenza`]="{ item }">
                {{ item.tipo_controllo == 2 ? "" : item.frequenza }}
                {{ item.des_frequenza }}
              </template>

              <!-- Colonna della Misura -->
              <template v-slot:[`item.misura`]="{ item }">
                <v-text-field
                  style="
                    border-radius: 5px;
                    font-size: 22px;
                    font-weight: bold;
                    line-height: 22px;
                    margin: 0;
                    max-width: 80px;
                  "
                  :class="
                    classeInputSuValore(item) + ' centered-input pa-0 ma-0'
                  "
                  v-show="
                    item.valore !== null &&
                    item.valore !== undefined &&
                    !isNaN(item.valore)
                  "
                  :background-color="sfondoInputSuValore(item)"
                  dense
                  flat
                  solo
                  hide-details
                  v-model="item.misura"
                />
                <div
                  style="text-align: left"
                  v-show="
                    item.valore == null ||
                    item.valore == undefined ||
                    isNaN(item.valore)
                  "
                >
                  <v-btn
                    icon
                    small
                    style="display: inline-block; vertical-align: middle"
                    @click="item.misura = item.misura == 1 ? 0 : 1"
                  >
                    <v-icon :color="item.misura == 1 ? 'green' : 'red'" large>{{
                      item.misura == 1 ? "mdi-checkbox-marked" : "mdi-close-box"
                    }}</v-icon>
                  </v-btn>
                  <span
                    :style="
                      'margin-left:5px;display:inline-block;vertical-align:middle;font-size:18px;font-weight:bold;color:' +
                      (item.misura == 1 ? 'green' : 'red')
                    "
                  >
                    {{ item.misura == true ? "OK" : "NOK" }}
                  </span>
                </div>
              </template>

              <!-- Colonna della conformità -->
              <!--<template v-slot:[`item.conforme`]="{ item }">
          <v-icon
            :color="item.conforme === 1 ? 'success' : 'grey'"
            @click="$set(item, 'conforme', 1)"
          >
            {{
              item.conforme === 1
                ? "mdi-checkbox-marked"
                : "mdi-checkbox-blank-outline"
            }}
          </v-icon>
          <v-icon
            :color="
              item.conforme === 0 ||
              item.conforme === null ||
              item.conforme === undefined
                ? 'primary'
                : 'grey'
            "
            @click="$set(item, 'conforme', 0)"
          >
            {{
              item.conforme === 0 ||
              item.conforme === null ||
              item.conforme === undefined
                ? "mdi-checkbox-intermediate"
                : "mdi-checkbox-blank-outline"
            }}
          </v-icon>
        </template>-->

              <!-- Colonna del bottone per il controllo della webcam -->
              <template v-slot:[`item.controllo_webcam`]="{ item }">
                <v-btn @click="clickControllo(item)">
                  <v-icon color="primary" large> mdi-camera </v-icon>
                </v-btn>
              </template>

              <!-- Spazio per la miniatura della foto da webcam -->
              <template v-slot:[`item.miniatura`]="{ item }">
                <div
                  :id="item.id_ciclo_dettaglio"
                  style="
                    background-repeat: no-repeat;
                    background-size: contain;
                    border: 1px solid black;
                    height: 100px;
                    margin-top: 5px;
                    position: relative;
                    width: 100px;
                  "
                ></div>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>

    <!-- Dialog della webcam della qualità -->
    <div
      style="
        background-color: rgba(33, 33, 33, 0.46);
        bottom: 0;
        height: 100%;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        width: 100%;
        z-index: 2;
      "
      v-if="controllo_webcam_visible"
    >
      <div
        style="height: 90%; left: 5%; position: absolute; top: 5%; width: 90%"
      >
        <Controllo
          @click_indietro="controllo_webcam_visible = false"
          :destinazione="'listener_controllo_qualita'"
          :id_articolo="work_order_sel.id_articolo"
          :immagine_standard_editor="immagine_standard_editor"
          :riferimento="id_ciclo_controllo_dettaglio_sel"
          :visible="visible"
        />
      </div>
    </div>

    <v-dialog v-model="dialog_conferma_salvataggio" width="unset">
      <v-card style="width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text">
            Conferma Salvataggio
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_conferma_salvataggio = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            Alcune caratteristiche non sono conformi. Si vuole procedere al
            salvataggio?
          </span>
          <v-container class="mb-0 pb-0" fluid>
            <v-row align="center" justify="center">
              <v-col cols="12">
                <v-btn
                  class="mr-5"
                  @click="
                    setControlli();
                    dialog_conferma_salvataggio = false;
                  "
                  small
                >
                  <v-icon color="success">mdi-check</v-icon>
                </v-btn>
                <v-btn @click="dialog_conferma_salvataggio = false" small>
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog di conferma attivazione modulo segnalazioni -->
    <v-dialog v-model="dialog_richiesta_segnalazione" width="unset">
      <v-card style="max-width: 500px">
        <v-toolbar color="indigo" dense>
          <v-toolbar-title class="white--text"> Segnalazione </v-toolbar-title>
        </v-toolbar>
        <v-card-text class="mt-5" style="overflow-y: auto">
          <span style="color: rgb(0, 0, 0); font-size: 18px">
            In base all'impostazione del ciclo di autocontrollo, è previsto l'invio di una segnalazione.
            Si vuole procedere?
          </span>
          <v-divider class="my-5"></v-divider>
          <v-container>
            <v-row align="center" justify="center">
              <v-col class="my-0 py-0" justify="center" cols="12">
                <v-btn class="mr-5" @click="chiudiESegnala" small>
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
                <v-btn @click="chiudiESalva" small>
                  <v-icon color="error"> mdi-close </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Windowframe delle segnalazioni -->
    <v-dialog class="ma-0 pa-0" v-model="windowframe_segnalazioni" width="90vw">
      <v-card
        class="mt-0 pa-0"
        height="calc(100vh - 100px)"
        style="overflow: hidden"
      >
        <div style="position: relative; height: 100%">
          <WindowFrame
            class="ma-0 pa-0"
            @click_chiudi="closeSegnalazioni"
            :component="'anomalie'"
            :input_args="input_args"
            @salvati_disegni="handleSalvatiDisegni"
            :key="windowframe_segnalazioni"
          />
        </div>
      </v-card>
    </v-dialog>

    <!-- Popup modifica header (posizione / visibilità). -->
    <v-dialog v-model="dialog_header_detail" width="unset" persistent>
      <HeaderDetail
        :key="dialog_header_detail"
        :modulo="`ESECUZIONE_${this.tipo_operazione}_CARATTERISTICHE`"
        @click_chiudi="dialog_header_detail = false"
        @salvataggio_effettuato="
          dialog_header_detail = false;
          getHeaders();
        "
      />
    </v-dialog>

    <!-- Overlay di caricamento -->
    <v-overlay :value="overlay" style="z-index: 10">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
  </v-card>
</template>
<script>
import Controllo from "@/views/PRODUCTION/Controllo/Controllo.vue";
import HeaderDetail from "@/components/TOOLS/HeaderDetail.vue";
import moment from "moment";
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import WindowFrame from "@/components/WINDOWFRAME/WindowFrame.vue";

export default {
  name: "ControlloQualita",
  components: {
    Controllo,
    HeaderDetail,
    SnackbarQV,
    WindowFrame,
  },
  props: {
    headers_controllo: {
      type: Array,
      default: () => [
        //{ text: "Controllo", sortable: false, value: "controllo" },
        {
          text: "Num. Riga",
          sortable: false,
          value: "num_riga",
        },
        {
          text: "Cod. Articolo",
          sortable: false,
          value: "cod_articolo",
        },
        {
          text: "Cod. Lotto",
          sortable: false,
          value: "cod_lotto",
        },
        {
          text: "Des. Caratteristica",
          sortable: false,
          value: "des_caratteristica",
        },
        { text: "Frequenza", sortable: false, value: "frequenza" },
        { text: "Valore Min.", sortable: false, value: "valore_min" },
        { text: "Valore", sortable: false, value: "valore" },
        { text: "Valore Max.", sortable: false, value: "valore_max" },
        { text: "Tolleranza", sortable: false, value: "tolleranza" },
        { text: "Des. Strumento", sortable: false, value: "des_strumento" },
        { text: "Note", sortable: false, value: "note" },
        { text: "Misura", sortable: false, value: "misura" },
        //{ text: "Conforme", sortable: false, value: "conforme" },
        //{ text: "Webcam", sortable: false, value: "controllo_webcam" },
        //{ text: "Miniatura", sortable: false, value: "miniatura" },
      ],
    },
    tipo_operazione: { type: String, default: "CONTROLLO" },
    visible: { type: Boolean, default: false },
    work_order_sel: { type: Object, default: () => {} },
  },
  data() {
    return {
      // Variabili d'appoggio
      controllo_singolo: false,
      dialog_richiesta_segnalazione_presentato: false,
      id_ciclo_controllo_dettaglio_sel: null,
      id_famiglia_articolo: null,
      immagine_standard_editor: "",
      input_args: {},
      testata_id: "",
      testata_revisione: "",

      // Modal
      dialog_header_detail: false,
      dialog_richiesta_segnalazione: false,
      controllo_webcam_visible: false,
      dialog_conferma_salvataggio: false,
      overlay: false,
      windowframe_segnalazioni: false,

      // Array
      items_controllo: [],
      headers_controllo_selezionati: [],
    };
  },
  computed: {},
  watch: {
    visible: {
      immediate: true,
      handler() {
        if (this.visible === true && this.work_order_sel != null) {
          this.controllo_singolo = false;
          this.getControlli();
          this.getHeaders();
        }
      },
    },
  },
  methods: {
    aggiungiImg(messaggio) {
      /* Recupero l'immagine nel messaggio
       * che è un base64 non splittato. */
      let photo = messaggio.detail.img;

      // Uso il base64 per valorizzare la src di un oggetto immagine
      let img = new Image();

      img.onload = function () {
        /* Ora ho un'immagine di cui posso conoscere altezza e larghezza,
         * e dimensiono il div in maniera da accoglierla senza stretcharla.
         * Voglio che le dimensioni dell'immagine non siano mai
         * superiori a 100 px; se lo sono scalo le dimesioni.*/
        if (img.width >= img.height && img.width > 100) {
          let width_nuova = 100;
          // Proporzione -> width_nuova : img.width = height_nuova : img.height
          let height_nuova = (width_nuova * img.height) / img.width;
          document.getElementById(messaggio.detail.id).style.width =
            width_nuova + "px";
          document.getElementById(messaggio.detail.id).style.height =
            height_nuova + "px";
          img.width = width_nuova;
          img.height = height_nuova;
        } else if (img.height > img.width && img.height > 100) {
          let height_nuova = 100;
          // Proporzione -> width_nuova : img.width = height_nuova : img.height
          let width_nuova = (height_nuova * img.width) / img.height;
          document.getElementById(messaggio.detail.id).style.width =
            width_nuova + "px";
          document.getElementById(messaggio.detail.id).style.height =
            height_nuova + "px";
        } else {
          document.getElementById(messaggio.detail.id).style.width =
            img.width + "px";
          document.getElementById(messaggio.detail.id).style.height =
            img.height + "px";
        }
      };

      img.src = photo;

      document.getElementById(messaggio.detail.id).style.backgroundImage =
        'url("' + img.src + '")';

      this.items_controllo.forEach((e) => {
        if (e.id_ciclo_dettaglio == messaggio.detail.id) {
          e.img = messaggio.detail.img;
        }
      });
    },
    chiudiESalva() {
      this.dialog_richiesta_segnalazione = false;
      this.setControlli();
    },
    chiudiESegnala() {
      this.input_args = {
        clear_on_save: true,
        destinazione: "",
        disegni_iniziali: [],
        id_articolo: 0,
        id_riferimento: this.work_order_sel.id_commessa_dettaglio,
        immagine_standard_editor: "",
        pk_riferimento: "id_commessa_dettaglio",
        riferimento: "commessa_dettaglio",
        return_array: true,
        show_close_button: true,
        show_editor_arrow_button: true,
        show_editor_camera_button: true,
        show_editor_circle_button: true,
        show_editor_color_picker_button: true,
        show_editor_crop_button: true,
        show_editor_edit_back_button: true,
        show_editor_edit_forward_button: true,
        show_editor_eraser_button: true,
        show_editor_free_draw_button: true,
        show_editor_large_size_button: true,
        show_editor_letter_case_button: true,
        show_editor_medium_size_button: true,
        show_editor_save_button: true,
        show_editor_small_size_button: true,
        show_editor_square_button: true,
        show_editor_tool_columns: true,
        show_editor_upload_button: true,
        tabella_supporto: "disegno",
        titolo_editor: "Editor",
        visible: true,
      };

      this.dialog_richiesta_segnalazione = false;
      this.windowframe_segnalazioni = true;
    },
    chkControlloSegnalabile() {
      let chk_is_segnalabile = false;

      this.items_controllo.forEach((c) => {
        // Verifico la conformità per le caratteristiche qualitative.
        if (
          c.genere == 1 &&
          c.invio_segnalazione == 1 &&
          (parseFloat(c.misura) < parseFloat(c.valore_min) ||
            parseFloat(c.misura) > parseFloat(c.valore_max))
        ) {
          chk_is_segnalabile = true;
        }

        // Verifico la conformità per le caratteristiche quantitative.
        if (
          c.genere == 0 &&
          c.invio_segnalazione == 1 &&
          parseInt(c.misura) === 0
        ) {
          chk_is_segnalabile = true;
        }

        // Verifico se devo mandare la segnalazione in qualsiasi caso.
        if (c.invio_segnalazione == 2) {
          chk_is_segnalabile = true;
        }
      });

      return chk_is_segnalabile;
    },
    classeInputSuValore(item) {
      let misura = Number(item.misura);
      let max = Number(item.valore_max);
      let min = Number(item.valore_min);
      if (isNaN(misura) || isNaN(min) || isNaN(max)) {
        return "";
      }

      if (misura < min || misura > max) {
        return "red-text";
      } else if (misura == min || misura == max) {
        return "orange-text";
      } else {
        return "green-text";
      }
    },
    clickSetControlli() {
      let chk_is_conforme = true;

      this.items_controllo.forEach((c) => {
        // Verifico la conformità per le caratteristiche qualitative.
        if (
          c.genere == 1 &&
          (parseFloat(c.misura) < parseFloat(c.valore_min) ||
            parseFloat(c.misura) > parseFloat(c.valore_max))
        ) {
          chk_is_conforme = false;
        }

        // Verifico la conformità per le caratteristiche quantitative.
        if (c.genere == 0 && parseInt(c.misura) === 0) {
          chk_is_conforme = false;
        }
      });

      if (!chk_is_conforme && this.controllo_singolo) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Salvataggio impossibile: tutte le caratteristiche devono essere conformi."
        );

        return;
      }

      if (chk_is_conforme === false) {
        this.dialog_conferma_salvataggio = true;
      } else {
        this.setControlli();
      }
    },
    closeSegnalazioni() {
      this.windowframe_segnalazioni = false;
      this.setControlli();
    },
    getHeaders() {
      const request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getheader",
          nome_modulo: `ESECUZIONE_${this.tipo_operazione}_CARATTERISTICHE`,
          token: localStorage.getItem("user_token"),
        },
      };
      this.$store.dispatch("api", request).then((res) => {
        if (res.data.length == 0) {
          this.headers_controllo_selezionati = JSON.parse(
            JSON.stringify(this.headers_controllo)
          );
          return;
        }

        this.headers_controllo_selezionati = new Array();

        res.data.sort((a, b) =>
          a.ordine < b.ordine ? -1 : a.ordine > b.ordine ? 1 : 0
        );

        res.data.forEach((h) => {
          if (h.visible == 1) {
            h.sortable = h.sortable == 1 ? true : false;
            this.headers_controllo_selezionati.push(h);
          }
        });
      });
    },
    handleSalvatiDisegni(arg) {
      const obj_tmp = {
        id_segnalazione: -1,
        pk_riferimento: arg.pk_riferimento,
        id_riferimento: arg.id_riferimento,
        riferimento: arg.riferimento,
        quantita: arg.quantita,
        tipo: arg.tipologia,
        note: arg.descrizione,
        cod_documento: this.work_order_sel.cod_commessa,
        num_documento: this.work_order_sel.cod_fase,
        cod_articolo: this.work_order_sel.cod_articolo,
        data_documento: moment().format("YYYY-MM-DD HH:mm:ss"),
      };

      this.windowframe_segnalazioni = false;
      this.overlay = true;

      const request = {
        controller: "Magazzino",
        method: "PUT",
        richiesta: {
          action: "setsegnalazioni",
          segnalazioni: [obj_tmp],
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            const request2 = {
              controller: "Magazzino",
              method: "PUT",
              richiesta: {
                action: "setsegnalazioniimmagini",
                token: localStorage.user_token,
                immagini: arg.imgs,
                id_segnalazione: res.data.segnalazioni[0].id_segnalazione,
              },
            };

            this.$store
              .dispatch("api", request2)
              .then((res2) => {
                this.overlay = false;
                if (res2.status === 200) {
                  this.$refs.SnackbarQV.print(
                    "success",
                    "Segnalazione registrata con successo!"
                  );
                  this.setControlli();
                }
              })
              .catch((err) => {
                this.overlay = false;
                console.error(err);
                this.$refs.SnackbarQV.print(
                  "error",
                  "Errore di comunicazione col server, non è stato possibile salvare le segnalazioni."
                );
              });
          } else {
            this.overlay = false;
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile salvare le segnalazioni."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV(
            "error",
            "Errore di comunicazione col server, non è stato possibile salvare le segnalazioni."
          );
        });
    },
    sfondoInputSuValore(item) {
      let misura = Number(item.misura);
      let max = Number(item.valore_max);
      let min = Number(item.valore_min);
      if (isNaN(misura) || isNaN(min) || isNaN(max)) {
        return "#ff9999";
      }

      if (misura < min || misura > max) {
        return "#ff9999";
      } else if (misura == min || misura == max) {
        return "#ffebcc";
      } else {
        return "#b3ffb3";
      }
    },
    clickChiudi() {
      this.$emit("click_chiudi");
    },
    clickControllo(item) {
      /* Se l'oggetto cliccato ha un'immagine, la metto in
       * prop per il componente delll'editor grafico, altrimenti
       * cancello l'eventuale immagine standard precedente. */
      if (
        item.img != null &&
        (item.img != null) != undefined &&
        item.img != ""
      ) {
        this.immagine_standard_editor = item.img;
      } else {
        this.immagine_standard_editor = "";
      }

      this.id_ciclo_controllo_dettaglio_sel = item.id_ciclo_dettaglio;
      this.controllo_webcam_visible = true;
    },
    getControlli() {
      if (this.work_order_sel === null) {
        return;
      }

      let request = {
        controller: "Magazzino",
        method: "POST",
        richiesta: {
          action: "getciclocontrolli",
          token: localStorage.getItem("user_token"),
          id_articolo: this.work_order_sel.id_articolo,
          id_commessa_dettaglio: this.work_order_sel.id_commessa_dettaglio,
          id_fase: this.work_order_sel.id_fase,
          quantita: this.work_order_sel.pezzi_registrati
            ? this.work_order_sel.pezzi_registrati
            : 0,
          ora_start: this.work_order_sel.ora_start,
          tipo: this.tipo_operazione,
        },
      };

      this.overlay = true;
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            // Resetto l'array di destinazione.
            this.items_controllo = new Array();

            if (res.data.length > 0) {
              this.testata_id = res.data[0]._id;
              this.testata_revisione = res.data[0].rev_ciclo_autocontrollo;
              this.id_famiglia_articolo = res.data[0].id_famiglia_articolo;
            }

            res.data.forEach((c) => {
              // Controllo che ogni caratteristica abbia la sua quantità.
              if (!c.pezzi_da_controllare) {
                c.pezzi_da_controllare = 1;
              }

              /* Aggiungo righe nella tabella in base alla
               * quantità della caratteristica. */
              for (let i = 0; i < parseInt(c.pezzi_da_controllare); i++) {
                const obj_tmp = Object.assign({}, c);
                delete obj_tmp.pezzi_da_controllare;
                obj_tmp.id_commessa = this.work_order_sel.id_commessa;
                obj_tmp.id_commessa_tempi =
                  this.work_order_sel.id_commessa_tempi;
                obj_tmp.id_macchina = this.work_order_sel.id_macchina;
                obj_tmp.id_lotto = c.id_lotto;
                obj_tmp.id_ciclo_autocontrollo = c.id_ciclo_autocontrollo;
                this.items_controllo.push(obj_tmp);
              }

              /* Registro il controllo singolo. Se c'è anche una
               * sola caratteristica a 1, il controllo è singolo. */
              if (c.controllo_singolo == 1) {
                this.controllo_singolo = true;
              }
            });
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.SnackbarQV.print("error", "Errore di comunicazione col server.");
        });
    },
    setControlli() {
      /* Se sono disponibili le segnalazioni al salvataggio,
       * e se non ho ancora fatto vedere il messaggio delle segnalazioni,
       * controllo se il verbale è passibile di segnalazione. */
      if (
        this.chkControlloSegnalabile() &&
        !this.dialog_richiesta_segnalazione_presentato
      ) {
        this.dialog_richiesta_segnalazione = true;
        this.dialog_richiesta_segnalazione_presentato = true;
        return;
      }

      /*if (
        this.items_controllo.filter(
          (e) => e.tipo_controllo == 2 && (e.img == "" || e.img == null)
        ).length > 0
      ) {
        this.$refs.SnackbarQV.print(
          "orange",
          "Scattare un'immagine per tutte le verifiche estetiche."
        );
        return;
      }*/

      /* Per i controlli che scattano in base alla quantità di
       * pezzi prodotti, segno la quantità attuale di produzione
       * del WO, anche in base al tipo di avanzamento. */
      this.items_controllo.forEach((elem) => {
        if (elem.tipo_controllo == 0) {
          if (this.work_order_sel.tipo_avanzamento == 3) {
            elem.quantita = this.work_order_sel.pezzi_avanzati_produzione_fase;
          } else if (this.work_order_sel.tipo_avanzamento == 3) {
            elem.quantita = this.work_order_sel.pezzi_avanzati_contenitori_fase;
          }
        }
      });

      this.items_controllo.forEach((elem) => {
        elem.data_controllo = moment().format("YYYY-MM-DD HH:mm:ss");
      });

      this.items_controllo.forEach((c) => {
        if (c.valore == null || c.valore == undefined || isNaN(c.valore)) {
          c.conforme = c.misura == 1 ? 1 : 0;
        } else if (
          c.valore !== null &&
          c.valore !== undefined &&
          !isNaN(c.valore)
        ) {
          if (c.misura < c.valore_min || c.misura > c.valore_max) {
            c.conforme = 0;
          } else if (c.misura == c.valore_min || c.misura == c.valore_max) {
            c.onforme = 1;
          } else {
            c.conforme = 1;
          }
        }
      });

      // Compongo la request in base alla configurazione del componente.
      let request = {
        controller: "Qualita",
        method: "PUT",
        richiesta: {
          action:
            this.tipo_operazione == "CONTROLLO"
              ? "setciclocontrolli"
              : this.tipo_operazione == "CAMPIONATURA"
              ? "setcampionatura"
              : "setciclocontrollimp",
          token: localStorage.getItem("user_token"),
          ciclo: this.items_controllo,
        },
      };

      this.overlay = true;
      // Faccio il dispatch della request.
      this.$store
        .dispatch("api", request)
        .then((res) => {
          this.overlay = false;
          if (res.status === 200) {
            this.$emit("eseguito_controllo");
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server."
            );
          }
        })
        .catch((err) => {
          this.overlay = false;
          console.error(err);
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server."
          );
        });
    },
  },
  created() {},
  mounted() {
    document
      .getElementById("listener_controllo_qualita")
      .addEventListener("nuova_img", this.aggiungiImg);
  },
};
</script>
<style scoped>
.green-text :deep(.v-text-field__slot input) {
  color: #006600;
}
.orange-text :deep(.v-text-field__slot input) {
  color: #995c00;
}
.red-text :deep(.v-text-field__slot input) {
  color: #990000;
}
</style>